import PropTypes from 'prop-types';
import { t } from 'bv-i18n';
import { EventIcons } from 'sportsbook-components';

const ShowMore = ({ badges }) => (
  <span className="inply-coupon-competition-more">
    <EventIcons badges={badges} />
    <span className="more">{t('javascript.more')}</span>
  </span>
);

ShowMore.propTypes = {
  badges: PropTypes.instanceOf(Array).isRequired,
};

export default ShowMore;
